import {Alert, Loader, Select, Stack, Text} from '@mantine/core'
import {useEffect} from 'react'

import {useActiveEquipmentYards} from 'src/equipment-yards/use-equipment-yards'

type ActiveYardSelectorProps = {
    value: string | null
    onChange: (yardId: string | null) => void
}

export function ActiveYardSelector({value, onChange}: ActiveYardSelectorProps) {
    const {data: yards, isLoading, isError} = useActiveEquipmentYards()

    useEffect(() => {
        if (yards?.length === 1 && value == null) {
            onChange(yards[0].id)
        }
    }, [onChange, value, yards])

    if (isLoading) {
        return <Loader size="sm" aria-label="Loading yards" />
    }
    if (isError) {
        return <Alert color="red">Could not load active yards.</Alert>
    }
    if (!yards || yards.length === 0) {
        return (
            <Alert color="yellow" title="No active yards configured">
                Ask an administrator to configure a yard in Settings before returning equipment.
            </Alert>
        )
    }

    return (
        <Stack gap={4}>
            <Select
                label="Return yard"
                placeholder="Choose a yard"
                data={yards.map((yard) => ({value: yard.id, label: yard.name}))}
                value={value}
                onChange={onChange}
                withAsterisk
            />
            <Text size="xs" c="dimmed">
                Yard location is informational; equipment assignments continue to use the shared
                fleet pool.
            </Text>
        </Stack>
    )
}
